import { searchForms } from "./search-form";

export const initSearchOverlay = (searchOverlay: HTMLElement): boolean => {
  const ACTIVE_CLASS = "is-active";

  const isOpen = (searchOverlay: HTMLElement): boolean =>
    searchOverlay.classList.contains(ACTIVE_CLASS);

  const hide = (searchOverlay: HTMLElement): boolean => {
    searchOverlay.setAttribute("aria-hidden", "true");
    searchOverlay.classList.remove(ACTIVE_CLASS);

    return true;
  };

  const show = (searchOverlay: HTMLElement): boolean => {
    searchOverlay.setAttribute("aria-hidden", "false");
    searchOverlay.classList.add(ACTIVE_CLASS);
    searchForms[0].input?.focus();

    return true;
  };

  const toggleVisibility = (searchOverlay: HTMLElement): boolean => {
    if (isOpen(searchOverlay) === true) {
      return hide(searchOverlay);
    }

    return show(searchOverlay);
  };

  const toggles: HTMLElement[] = [
    ...(<NodeListOf<HTMLElement>>(
      document.querySelectorAll(".js-search-overlay-toggle")
    )),
  ];

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", () => toggleVisibility(searchOverlay));
  });

  window.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") {
      return false;
    }

    return hide(searchOverlay);
  });

  return hide(searchOverlay);
};

const searchOverlay: HTMLElement | null =
  document.querySelector(".js-search-overlay");

if (searchOverlay instanceof HTMLElement) {
  initSearchOverlay(searchOverlay);
}
